<template lang="pug">
	.settings-track-manager
		.filter-wrapper
			input.form-control.form-control-sm(v-model="search")
		.select-wrapper
			select.custom-select.custom-select-sm.select(v-on:change="changeSetting($event.target.value)")
				option(:value="-1") Select project
				optgroup(v-for="template in templates" :label="metadataTemplates[template].title")
					option(v-for="project in projects[template]" :value="project.id" :selected="parseInt(setting.value) === project.id" :class="{'not-uploaded': !project.AdditionalData.hasOwnProperty('templateFolder') && !project.AdditionalData.hasOwnProperty('projectFolder')}" :disabled="!project.AdditionalData.hasOwnProperty('templateFolder') && !project.AdditionalData.hasOwnProperty('projectFolder')") {{project.title}}
</template>

<script>
	import Screen 						from './../../mixins/screen'

	import { Project } 					from './../../services/Project'

	export default {
		name: "SettingsTagMerger",
		mixins: [Screen],
		screen: {
			updateOn: ["Projects Changed"],
			events: {
				'Projects By Template Received': function (projects) {
					this.allProjects = _.clone(projects);
					this.projects = projects;
					this.templates = Object.keys(projects);
				}
			}
		},
		props: ["setting"],
		data() {

			this.projects = {};
			this.templates = [];
			this.metadataTemplates = {};

			return {
				search: '',
				showed: true
			}
		},
		watch: {
			search(val) {
				val = val.toLowerCase();
				if (val.length === 0) {
					this.projects = _.clone(this.allProjects);
				} else {
					let keys = Object.keys(this.allProjects);
					for (let i = 0; i < keys.length; i++) {
						this.projects[keys[i]] = _.filter(this.allProjects[keys[i]], project => project.title.toLowerCase().includes(val));
					}
				}
			}
		},
		methods: {

			collectData() {

				if (!Project.SelectedProject) return;

				let settings = Settings.SettingsByProjectByCodename[Project.SelectedProject.id] || {};

				if (Project.SelectedProject.template_id === 5) {
					if (settings['mobile-creative']) this.setting = settings['mobile-creative'];
				} else {
					if (settings['desktop-creative']) this.setting = settings['desktop-creative'];
				}

				let templates = [];
				if (Project.SelectedProject.template_id === 5) {
					templates = Object.keys(Metadata.Templates).filter(id => id !== '5');
				} else {
					templates = Object.keys(Metadata.Templates).filter(id => id === '5');
				}

				Server.sendToSocket({
					GetTemplatesProjects: {
						templates: templates
					}
				});

				this.projects = {};


				this.metadataTemplates = Metadata.Templates;


			},

			changeSetting(value) {
				Settings.saveSettingValue(this.setting, value);
			}
		}
	}
</script>

<style lang="sass">

	.settings-track-manager


		.filter-wrapper
			display: flex
			flex-direction: row
			width: 95%

		.select-wrapper
			.select
				border: 1px solid #23282c
				width: 95%

			optgroup
				color: #73818f

			option
				color: #f3f4f5

			.not-uploaded
				color: #bf9494

</style>
